module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-TUMBLR.822005dc.png";